import React from 'react';
import LocalStorage from '../../providers/LocalStorage';
import { Button, Hidden, Grid, Divider, Fab, Snackbar, Fade, Drawer, Dialog, DialogContent, DialogActions, Accrodion, AccrodionDetails, Accordion, AccordionDetails } from '@material-ui/core';

import Utils from '../../providers/Utils';
import WsC from './providers/WsC';
import CustomAppBar from '../../commons/AppBar';
import SpecificComponent from '../../commons/SpecificComponent';
import LoadingDialog from '../../commons/LoadingDialog';
import ListaChestionare from './ListaChestionare';
// import ListaIntrebariChestionare from '../../commons/lists/ListaIntrebariChestionare'
// import AddIntrebare from '../../commons/dialogs/AddIntrebare'
// import DialogRaspunsuri from '../../commons/dialogs/DialogRaspunsuri'
// import ListaChestionare from '../../commons/lists/ListaChestionare';
// import PreviewChestionar from '../../commons/dialogs/PreviewChestionar'
// import AlertChestionar from '../../commons/dialogs/AlertChestionare';






// import LoadingDialog from '../../commons/dialogs/LoadingDialog';
// import ListaIntrebariChestionareTemplate from '../../commons/lists/ListaIntrebariChestionareTemplate';
// import backgroundCh from '../../Pics/background.png'


import { ReactComponent as CogSolid } from './Icoane Font Awesome/cog-solid.svg';
import { ReactComponent as RocketSolid } from './Icoane Font Awesome/rocket-solid.svg';
import { ReactComponent as FileInvoiceSolid } from './Icoane Font Awesome/file-invoice-solid.svg';
import { ReactComponent as FolderSolid } from './Icoane Font Awesome/folder-solid.svg';
import ListaIntrebariChestionareTemplate from './ListaIntrebariChestionareTemplate';
import ListaIntrebariChestionare from './ListaIntrebariChestionare';
import AddIntrebare from './AddIntrebare';
import DialogRaspunsuri from './DialogRaspunsuri';
import AlertChestionar from './AlertChestionar';
import AlertNew from '../../commons/dialogs/AlertNew';




export default class CreeazaChestionar extends SpecificComponent {
    constructor(props) {
        super(props);
        this.raspunsuri = React.createRef();
        this.generateRapsuns = React.createRef();
        this.raspunsuriInsert = React.createRef();
        this.state = {
            objChestionar: { nume: '' },
            objEvaluare: { denumire: '' },
            strStatusText: '',
            isStatus: false,
            nrPost: 0,
            listIntrebari: [],
            listTemplateIntrebari: [],
            listTempIntrebari: [],
            listBeneficiariAlocati: [],
            listPosturi: [],
            strTip: 'radio',
            listTipuriIntrebari: new Utils().tipIntrebari,
            strTitluIntrebare: '',
            isOpenIntrebare: false,
            objIntrebareInfo: { tip: '', id: '', id_parent: null },
            isOpenUpdateIntrebare: false,
            listRaspunsuri: [],
            listaRaspunsuriTemplate: [],
            listVarianteRaspuns: [],
            isOpenBeneficiari: false,
            isOpenAlert: false,
            listCategorii: [],
            isShowCategorii: true,
            listChestionareTemplate: [],
            isShowChestionareT: false,
            objCategorie: {},
            categoriileMele: [],
            listChestionare: [],
            isChestionareleMele: false,
            listIntrebariCS: [],
            objChestionarSelectat: {},
            objChestionarTemp: { nume: '', id: 0 },
            isDragCategorie: false,
            isShowIntrebariCs: false,
            nrIntrebari: 0,
            listRaspunsuriTemp: [],
            isShowPreview: false,
            isOpenDrawerRight: false,
            isOpenDrawerLeft: false,
            isOpenDeleteChestionar: false,
            isOpenEmailuri: false,
            emailObj: { email: '', nume: '' },
            listEmailuriEv: [],
            listEmailuriToate: [],
            isOpenEmailuriList: false,
            rezultateList: [],
            isOpenTrimiteA: false,
            usersAprobare: [],
            userAprobare: '',
            loading: false,
            isOpenSnack: false,
            strMesajSnack: '',
            openRespins: false,
            motivRespins: '',
            lastIdIntrebare: null,
            panel1: false,
            isOpenTeren: false,
            isOpenAgentiTeren: false,
            listUseri: [],
            listUseriAll: [],
            loadingDialog: false,
            isOpenMagazin: false,
            isOpenMagazine: false,
            vFields: '',
            allEmailsChecked: false,
            listCompletatoriSelectati: [],
            listCompletatoriToti: [],
            isOpenCompletatori: false,
            isOpenUtiliatoriCompletatori: false,
            loadingChestionareUsers: false,
            userTrimisAprobare: {},
            panelTempChestionar: false,
            panelTempCategorii: false,
            openSettings: false,
            popUpSalvare: false,
            alertView:false

        }
    }

    componentDidMount() {
        this.access()
        this.scrollTop()
        this.getChestionar()


    }

    u = new Utils()
    ls = new LocalStorage().GetUserData()

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    scrollTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    objIntrebare = {}

    goToCategorieTemplate = (c) => {


        this.getChestionareTemplate(c)



    }

    getWindowDimentions = () => {
        let windowWidth = window.innerWidth

        if (windowWidth <= 800) {
            return windowWidth
        } else {
            return 360
        }

    }









    getChestionareTemplate = async (cat) => {
        let ws = new WsC();

        let ls = new LocalStorage();

        let templateChestionare = await ws.customSelect('select * from template_chestionare where id_categorie = @p2', {
            p1: ls.GetUserData().IdBeneficiar,
            p2: cat.id
        })

        // console.log('templateChestionare :', templateChestionare);
        if (templateChestionare.Succes) {
            this.setState({
                listChestionareTemplate: templateChestionare.Content,
                isShowCategorii: false,
                isShowChestionareT: true,
                objCategorie: cat

            })
        }
    }

    goToChestionareleMele = (c) => {
        this.getChestionareleMele(c)
    }

    getChestionareleMele = async (cat) => {
        let ws = new WsC();

        let ls = new LocalStorage().GetUserData();

      
        let _chest = ws.customSelect(`select c.id,c.hash_id as hash_id, c.titlu, c.nume,c.statusul,c.id_categorie from chestionare c where baza_date = @p1 and isnull(este_template,0) != 0 and isnull(c.sters,0) != 1 `,
            {
                p1: ls.InfoUser.Database,


            })


        let _posturi = ws.customSelect('select * from beneficiari_posturi_lucru where id_beneficiar = @p1', {
            p1: 1
        })



        let [chest, posturi] = await Promise.all([_chest, _posturi])


        // console.warn('categorie', cat)
        console.warn('chest :', chest);
        console.log('posturi :', posturi);

        if (chest.Succes && posturi.Succes) {


            // let counter = chest.Content.length

            let cloneChest = [...chest.Content]

            let categorie = cat.id === 0 ? null : cat.id

            let chestionareFilter = cloneChest.filter(c => c.id_categorie === categorie)








            // for (let i = 0; i < counter; i++) {





            //     for (let j = 0; j < counter; j++) {
            //         if (chestionareFilter.filter(c => c.id === cloneChest[j].id).length === 0) {

            //             chestionareFilter.push({ nume: cloneChest[j].nume, id: cloneChest[j].id })
            //         }
            //     }

            // }

            // console.log('chestionareFilter :', chestionareFilter);



            this.setState({
                listChestionare: chestionareFilter,
                listPosturi: posturi.Content,
                isShowCategorii: false,
                isChestionareleMele: true,
                objCategorie: cat
            })
        }



    }


    onDragStartChestionar = (c) => {
        //  console.log('c :', c);

        this.objChestionar = c
        this.objIntrebare = null
    }


    goBackCategorii = () => {
        this.setState({
            isShowCategorii: true,
            isShowPreview: false,
            isShowChestionareT: false,
            isChestionareleMele: false
        })
    }


    goToChestionarSelectat = (c) => {


        // console.log('c :', c);

        this.setState({
            isChestionareleMele: false,
            objChestionarTemp: c
        }, () => {
            this.getChestionarSelectat()
        })
    }

    getChestionarSelectat = async () => {

        let ws = new WsC();


        // console.log('nrIdChestionar :', this.state.objChestionarTemp);

        let getChestionar = await ws.customSelect('select * from chestionare where id = @p1', {
            p1: this.state.objChestionarTemp.id
        })

        // console.log('getChestionar :', getChestionar);
        if (getChestionar.Succes) {
            this.setState({
                objChestionarSelectat: getChestionar.Content[0],
                strStatusText: getChestionar.Content[0].statusul,
                isStatus: getChestionar.Content[0].statusul !== 'Publicat' ? false : true,

            }, () => {

                this.getIntrebari()

            })
        }
        // console.log('getChestionar :', getChestionar);


    }

    getIntrebari = async () => {
        let ws = new WsC();


        let _intrebari = ws.customSelect('select * from chestionare_intrebari where id_chestionar = @p1 and isnull(inactiv,0) != 1 and (isnull(id_parent,0) = 0 or id_parent = 0) order by isnull(ordinea,0) asc, id asc', {
            p1: this.state.nrIdChestionar
        })


        let _intrebariS = ws.customSelect('select * from chestionare_intrebari where id_chestionar = @p1 and isnull(inactiv,0) != 1 and (isnull(id_parent,0) = 0 or id_parent = 0) order by isnull(ordinea,0) asc, id asc', {
            p1: this.state.objChestionarTemp.id
        })

        let _templateIntrebari = ws.customSelect('select * from template_chestionare_intrebari where id in (select id_intrebare from template_legaturi_intrebari where id_beneficiar = @p1 and isnull(sters, 0) != 1 ) and isnull(inactiv,0) != 1  order by id asc', {
            p1: 1
        })

        let _categorii = ws.customSelect('select * from chestionare_categorii_template where id in (select id_categorie from template_chestionare where isnull(sters,0) != 1) and use_in_pm = 1 and isnull(inactiv,0) != @p1 order by id asc', {
            p1: 1
        })

        let _categChesti = ws.customSelect('select * from chestionare_categorii where id in (select id_categorie from chestionare where isnull(sters,0) != 1) and isnull(inactiv,0) != @p1 order by id asc', {
            p1: 1
        })



        let [intrebari, templateIntrebari, categorii, intrebariS, categChest] = await Promise.all([_intrebari, _templateIntrebari, _categorii, _intrebariS, _categChesti])



        // console.log('templateIntrebari :', templateIntrebari);



        console.log('intrebariS :', intrebariS);


        console.log('intrebari :', intrebari);

        //    console.log('templateIntrebari :', templateIntrebari);

           console.log('categorii :', categorii);

        //   console.log('departamente :', departamente);


        if (intrebari.Succes && templateIntrebari.Succes && categorii.Succes && categChest.Succes) {


            // console.warn('intrebari :', intrebari);
            // console.log('templateIntrebari :', templateIntrebari);

            let cloneCategorii = [...categorii.Content]

            let cloneCategChest = [...categChest.Content]

            let cloneTintrebari = [...templateIntrebari.Content]

            let cloneIntrebari = [...intrebariS.Content]

            let counterT = cloneTintrebari.length < 10 ? cloneTintrebari.length : 10

            let counterI = cloneIntrebari.length

            let intrebariTemplate = []

            for (let i = 0; i < counterT; i++) {
                cloneTintrebari[i].temp = 1


                intrebariTemplate.push(cloneTintrebari[i])
            }

            for (let i = 0; i < counterI; i++) {
                cloneIntrebari[i].temp = 0
            }




            cloneCategChest.push({ id: 0, nume: 'Chestionarele mele' })

            // console.log('this.state.objCategorie.id :', this.state.objCategorie.id);
            //  console.log('    cloneCategorii.length + 1 :', cloneCategorii.length + 1);
            // console.log('this.state.isDragCategorie :', this.state.isDragCategorie);

            console.log('intrebariTemplate :>> ', intrebariTemplate);

            console.log('intrebari.Content :>> ', intrebari.Content);

            if (this.state.objCategorie.id === 0 && this.state.isDragCategorie !== true) {

                this.setState({
                    listIntrebariCS: cloneIntrebari,
                    listIntrebari: intrebari.Content,
                    categoriileMele: cloneCategChest,
                    isChestionareleMele: false,
                    isDragCategorie: false,
                    isShowIntrebariCs: true,
                    nrIntrebari: intrebari.Content.length,
                    listCategorii: cloneCategorii,
                    listTemplateIntrebari: intrebariTemplate
                }, () => {



                    console.warn('last id intrebare else', this.state.listTemplateIntrebari)

                    // console.log('listCategorii :', this.state.listCategorii);
                    this.generateRapsuns.current.getRaspunsuri(this.state.lastIdIntrebare)

                    this.getRaspunsuri()
                    this.getRaspunsuriTemp()
                })
                //      console.log('getRaspunsuri :');
            } else {


                this.setState({
                    listIntrebari: intrebari.Content,
                    listCategorii: cloneCategorii,
                    categoriileMele: cloneCategChest,

                    isDragCategorie: false,
                    listTemplateIntrebari: intrebariTemplate
                }, () => {


                    //       console.log('listCategorii :', this.state.listCategorii);
                    console.warn('last id intrebare else', this.state.listTemplateIntrebari)
                    this.generateRapsuns.current.getRaspunsuri(this.state.lastIdIntrebare)
                    this.getRaspunsuri()
                    this.getRaspunsuriTemp()
                })
            }


        }
    }

    changeText = nume => ev => {
        let objEvaluare = { ...this.state.objEvaluare }

        // console.log('ev :', ev);
        objEvaluare[nume] = ev.target.value

        this.setState({
            objEvaluare: objEvaluare
        })
    }

    updateTitluChestionar = async () => {

        let ws = new WsC();



        // let updateChestionar =
        ws.update('chestionare', { nume: this.state.objChestionar.titlu, titlu: this.state.objChestionar.titlu }, { id: this.props.match.params.idchestionar })

        // let updateEvaluare = 



    }

    getRaspunsuri = async () => {

        let ws = new WsC();

        let getRaspunsuri = await ws.customSelect('select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1', {
            p1: '1'
        })




        // console.log('getRaspunsuri :', getRaspunsuri);
        if (getRaspunsuri.Succes) {
            this.setState({ listRaspunsuri: getRaspunsuri.Content }, () => {

                let chestScroll = document.getElementById("chestionare-list-intrebari-scroll-view");
                chestScroll.scrollTop = chestScroll.scrollHeight

                console.warn('chestsScroll :', chestScroll);
            })

        }

    }

    getRaspunsuriTemp = async (t = null) => {
        let ws = new WsC();




        // let idIntrebari = new Set(this.state.listTempIntrebari.map(i => i.id))
        // idIntrebari = [...idIntrebari]





        let raspunsuriTemp = await ws.customSelect('select * from template_chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0)!= @p1 ', {
            p1: 1
        })









        if (raspunsuriTemp.Succes) {

            let intrebari = [...this.state.listTempIntrebari]


            let raspunsuri = [...raspunsuriTemp.Content]

            // let raspunsuriFilter = [];






            for (let i = 0, n = intrebari.length; i < n; i++) {

                let filterRasp = raspunsuri.filter(r => r.id_intrebare === intrebari[i].id)



                for (let k = 0; k < 10; k++) {
                    let item = filterRasp[Math.floor(Math.random() * filterRasp.length)];

                    if (item) {
                        item['nr_raspunsuri'] = item.nr_raspunsuri ? item.nr_raspunsuri + 1 : 1
                    }



                }

                for (let j = 0, n = filterRasp.length; j < n; j++) {
                    filterRasp[j].classC = 1;
                    filterRasp[j].img_src = filterRasp[j].img_src ? filterRasp[j].img_src : ''
                    filterRasp[j].tip = filterRasp[j].tip ? filterRasp[j].tip : ''
                    filterRasp[j].color = new Utils().culoriCharts(filterRasp[j].id)
                    filterRasp[j].suma = ((filterRasp[j].nr_raspunsuri / 10) * 100).toFixed(1).split('.')[1] >= 5 ? Math.ceil(((filterRasp[j].nr_raspunsuri / 10) * 100)) : ((filterRasp[j].nr_raspunsuri / 10) * 100).toFixed(0)
                    // filterRasp[j].suma_cati_au_raspuns = ((filterRasp[j].nr_raspunsuri / intrebari[i].cati_au_raspuns) * 100).toFixed(1).split('.')[1] >= 5 ? Math.ceil(((raspuns.nr_raspunsuri / intrebari[i].cati_au_raspuns) * 100)) : ((raspuns.nr_raspunsuri / intrebari[i].cati_au_raspuns) * 100).toFixed(0)

                }

                intrebari[i].raspunsuri = filterRasp
                intrebari[i].tip_chart = "Vertical"

                if (intrebari[i].id_parent !== null) {
                    let idx = intrebari.findIndex(intr => intr.id === intrebari[i].id_parent)

                    // console.log('idx id_parent :>> ', idx);

                    if (idx !== -1) {
                        intrebari[i].intrebare_parent = intrebari[idx].intrebare
                    }

                    // console.log('intrebari[i] :>> ', intrebari[i]);


                }
            }

            intrebari = intrebari.filter(i => i.id_parent === null)

            //  console.log('intrebari[i] :', intrebari);

            this.setState({
                listRaspunsuriTemp: intrebari,
                // listTempIntrebari: intrebari
            }, () => {
                if (t) {
                    this.goToTemplate()
                }
            })
        }
    }

    changeChartType = (i, ev) => {
        // console.log('i :', i);
        //   console.log('ev.target.value :', ev.target.value);

        let cloneIntrebari = [...this.state.listRaspunsuriTemp]

        let idx = cloneIntrebari.findIndex(c => c.id === i.id)

        cloneIntrebari[idx].tip_chart = ev.target.value

        this.setState({ listRaspunsuriTemp: cloneIntrebari })
    }

    handleChange = name => ev => {

        let oldState = { ...this.state.objChestionar }
        oldState[name] = ev.target.value
        this.setState({
            objChestionar: oldState,
        }, () => {

        });
    };



    openIntrebariTemplate = () => {
        this.setState({
            isOpenDrawerRight: true,
            panel1: false
        })
    }

    openChestionarTemplate = () => {
        this.setState({
            isOpenDrawerLeft: true,
            panel1: false
        })
    }





    getChestionar = async () => {

        let ws = new WsC();

        console.log('new Ls().GetUserData() :>> ', new LocalStorage().GetUserData());




        let getChestionar = await ws.customSelect('select * from chestionare where id = @p1', {
            p1: this.props.match.params.idchestionar
        })


        console.log('getChestionar :', getChestionar);
        // console.log('getEvaluare :', getEvaluare);

        if (getChestionar.Succes) {


            console.log('getChestionar :>> ', getChestionar);
            this.setState({
                objChestionar: getChestionar.Content[0],
                strStatusText: getChestionar.Content[0].statusul,
                isStatus: getChestionar.Content[0].statusul !== 'Publicat' ? false : true,
                nrPost: getChestionar.Content[0].id_post_lucru,
                nrIdChestionar: this.props.match.params.idchestionar,

            }, () => {

                this.getIntrebari()

            })
        }



    }

    deleteChestionar = async () => {
        let ws = new WsC();

        let deleteChestionar =await ws.update('chestionare', { sters: 1 }, { id: this.props.match.params.idchestionar })



        if (deleteChestionar.Succes) {
            this.props.history.goBack()
        }
    }

    updateChestionar = async () => {
        let ws = new WsC();

        let ls = new LocalStorage();

        let updateObj = {
            descriere_afisata: this.state.objChestionar.descriere_afisata || "",
            id_beneficiar: ls.GetUserData().IdBeneficiar || "",
            id_post_lucru: this.state.nrPost || "",
            nume: this.state.objChestionar.nume || "",
            obs_interne: this.state.objChestionar.obs_interne || "",
            statusul: this.state.strStatusText || "",
            titlu: this.state.objChestionar.titlu || "",

        }

        // console.log('updateObj :', updateObj);

        let updateChestionar = await ws.update('chestionare', updateObj, { id: this.state.objChestionar.id })

        if (updateChestionar.Succes) {
            let cloneChestionar = { ...this.state.objChestionar }


            cloneChestionar.statusul = this.state.strStatusText


            this.setState({
                objChestionar: cloneChestionar,
                isOpenSnack: true,
                strMesajSnack: `Datele au fost salvate`
            })
        } else {
            this.setState({
                isOpenSnack: true,
                strMesajSnack: `Ceva nu a mers cum trebuie, va rugam incercati din nou`
            })
        }

        // console.log('updateChestionar :', updateChestionar);
    }

    changeStatus = () => {
        if (this.state.isStatus === false) {
            this.setState({ strStatusText: 'In dezvoltare' })
        } else {
            this.setState({ strStatusText: 'Publicat' })
        }

    }


    // getBeneficiariAlocati = async () => {
    //     let ws = new WsC();

    //     let ls = new LocalStorage()

    //     let beneficiariAlocati = await ws.customSelect(`select c.id as idchestionar, b.nume,p.nume_afisat as post_lucru, cb.id as id_legatura
    //     from chestionare c
    //      left join chestionare_beneficiari cb on (c.id = cb.id_chestionar)
    //       left join beneficiari b on (cb.id_beneficiar = b.id)
    //       left join beneficiari_posturi_lucru p on (p.id_beneficiar = cb.id_beneficiar and p.id = cb.id_post_lucru)
    //    where c.id = @p1 and cb.id_beneficiar = @p2 and isnull(cb.sters,0) != 1
    //    `, {
    //         p1: this.props.match.params.idchestionar,
    //         p2: ls.GetUserData().IdBeneficiar
    //     })

    //     // console.log('beneficiariAlocati :', beneficiariAlocati);

    //     if (beneficiariAlocati.Succes) {


    //         this.setState({ listBeneficiariAlocati: beneficiariAlocati.Content })
    //     }
    // }


    // getPosturi = async () => {

    //     let ws = new WsC();

    //     let ls = new LocalStorage()

    //     let posturi = await ws.customSelect('select * from beneficiari_posturi_lucru where id_beneficiar = @p1 and isnull(sters,0) !=1', {
    //         p1: ls.GetUserData().IdBeneficiar
    //     })

    //     if (posturi.Succes) {

    //         this.setState({
    //             listPosturi: posturi.Content,
    //         })
    //         // console.log('posturi :', posturi);
    //     }


    // }






    insertIntrebare = async () => {

        if (this.state.objIntrebareInfo.id === null) {

            if (this.state.nrIdChestionar === 0) {
                await this.insertChestionar()
            }

            let ws = new WsC();

            let objToInsert = {
                id_chestionar: this.state.nrIdChestionar,
                tip: 'radio',
                id_categorie: 1,
                intrebare: this.state.strTitluIntrebare,
                // ordinea:this.state.listIntrebari.length + 1


            }

            console.log('objToInsert :', objToInsert);

            console.log('this.state.listIntrebari :>> ', this.state.listIntrebari);


            let insertIntrebare = await ws.insert('chestionare_intrebari', objToInsert)


            //  console.log('insertIntrebare :', insertIntrebare);

            if (insertIntrebare.Succes) {
                let cloneIntrebari = [...this.state.listIntrebari]

                objToInsert.id = insertIntrebare.Content[0].id
                cloneIntrebari.push(objToInsert)

                // console.log('objToInsert :', objToInsert);
                let raspuns = { label: '', id_intrebare: insertIntrebare.Content[0].id }

                if (objToInsert.tip === 'text') {
                    await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)
                    //  console.log('object :', insertRaspuns);
                }

                objToInsert.id_parent = null
                this.setState({
                    listIntrebari: cloneIntrebari,
                    objIntrebareInfo: objToInsert,
                    listTipuriIntrebari: new Utils().tipIntrebari,
                }, () => {
                    this.getChestionar()
                })

            }
        }






    }

    insertFromTemplate = async () => {
        // let ws = new WsC();

        // let objToInsert = {
        //     id_chestionar: this.state.objChestionar.id,
        //     tip: this.state.objIntrebareInfo.tip,
        //     id_categorie: 1,
        //     intrebare: this.state.objIntrebareInfo.intrebare

        // }

        //  console.log('objToInsertFrom template :', objToInsert);




        // let insertIntrebare = await ws.insert('chestionare_intrebari', objToInsert)


        // console.log('insertIntrebare :', insertIntrebare);

        // if (insertIntrebare.Succes) {
        //     let cloneIntrebari = [...this.state.listIntrebari]

        //     objToInsert.id = insertIntrebare.Content[0].id
        //     cloneIntrebari.push(objToInsert)

        //     let raspuns = { label: '', id_intrebare: insertIntrebare.Content[0].id }

        //     if (objToInsert.tip === 'text') {
        //         let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)
        //         console.log('object :', insertRaspuns);
        //     }
        //     this.setState({
        //         listIntrebari: cloneIntrebari,
        //         strTitluIntrebare: '',
        //         isOpenIntrebare: false
        //     })

        // }



    }


    deleteIntrebare = async (i) => {
        //   console.log('i :', i);

        let ws = new WsC();

        let deleteIntrebare = await ws.update('chestionare_intrebari', { inactiv: 1 }, { id: i.id })

        if (deleteIntrebare.Succes) {
            let cloneIntrebari = [...this.state.listIntrebari]

            let idx = cloneIntrebari.findIndex(c => c.id === i.id)

            cloneIntrebari.splice(idx, 1)

            this.setState({
                listIntrebari: cloneIntrebari,
                isOpenUpdateIntrebare: false
            })
        }
    }



    updateIntrebare = async (a, b) => {

        let ws = new WsC();

        // console.log('a,b :', a, b);

        let updateIntrebare = await ws.update('chestionare_intrebari', a,
            b)

        if (updateIntrebare.Succes) {

            let cloneIntrebari = [...this.state.listIntrebari]

            let idx = cloneIntrebari.findIndex(i => i.id === this.state.objIntrebareInfo.id)

            // console.warn('this.state.objIntrebareInfo :', this.state.objIntrebareInfo);
            // console.warn('idx',idx)
            //console.warn('cloneIntrebari', cloneIntrebari)


            if (idx !== -1) {
                cloneIntrebari[idx].intrebare = this.state.strTitluIntrebare
                cloneIntrebari[idx].tip = a.tip
                cloneIntrebari[idx].motivatie_label = a.motivatie_label


                this.setState({
                    listIntrebari: cloneIntrebari,
                    strTip: a.tip,
                    objIntrebareInfo: cloneIntrebari[idx],
                    isOpenUpdateIntrebare: false,

                }, () => {
                    this.generateRapsuns.current.getRaspunsuri();
                })

            }


        }
    }

    goToIntrebare = (i) => {
        // console.log('intrebare info :', i);

        let cloneRaspunsuri = [...this.state.listRaspunsuri]

        let varianteRaspuns = cloneRaspunsuri.filter(r => r.id_intrebare === i.id)

        // console.log('varianteRaspuns :', varianteRaspuns);
        this.setState({
            objIntrebareInfo: i,
            strTitluIntrebare: i.intrebare,
            isOpenUpdateIntrebare: true,
            listVarianteRaspuns: varianteRaspuns
        }, () => {
            this.generateRapsuns.current.getTipIntrebare();
            this.raspunsuri.current.openTrue();
            this.generateRapsuns.current.getRaspunsuri();
        })
    }

    // getRaspunsuri = async () => {

    //     let ws = new WsC();

    //     let getRaspunsuri = await ws.customSelect('select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1', {
    //         p1: '1'
    //     })




    //     console.log('getRaspunsuri :', getRaspunsuri);
    //     if (getRaspunsuri.Succes) {
    //         this.setState({ listRaspunsuri: getRaspunsuri.Content })
    //     }

    // }

    // insertBeneficiarAlocat = async () => {


    //     let ws = new WsC()

    //     let ls = new LocalStorage()


    //     let insertBeneficiar = await ws.insert('chestionare_beneficiari',
    //         {
    //             id_chestionar: this.state.objChestionar.id,
    //             id_beneficiar: ls.GetUserData().IdBeneficiar,
    //             id_post_lucru: this.state.nrPost
    //         })

    //     if (insertBeneficiar.Succes) {




    //         this.setState({
    //             isOpenSnack: true,
    //             strMesajSnack: `Datele au fost salvate`,
    //             isOpenBeneficiari: false
    //         }, () => {
    //             this.getBeneficiariAlocati()
    //         })
    //     } else {
    //         this.setState({
    //             isOpenSnack: true,
    //             isMesajSnack: `Ceva nu a mers cum trebuie, va rugam incercati din nou`,
    //             isOpenBeneficiari: false
    //         })
    //     }

    // }

    // deleteBeneficiar = async (b) => {

    //     let ws = new WsC();

    //     //console.log('b :', b);


    //     let u = new Utils();

    //     let date = u.updateSqlNow();


    //     let deleteBeneficiar = await ws.update('chestionare_beneficiari', { sters: 1, sters_la: date }, { id: b.id_legatura })

    //     if (deleteBeneficiar.Succes) {
    //         this.getBeneficiariAlocati()
    //     }
    // }


    onDragStartTemplate = (t, r) => {
        // console.log('t :', t);



        this.objIntrebare = t
    }
    dragOver = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    drop = async (d) => {
        // console.log('d :', d);

        let ws = new WsC()

        let ls = new LocalStorage()

        let userData = ls.GetUserData()

        // console.log('userData :', userData);

        // console.log('this.objIntrebare :', this.objIntrebare);

        if (this.objIntrebare.temp === 1) {

            let newIntrebare = await ws.getData('Evaluari/InsertIntrebareTemplate', {
                idChestionar: this.props.match.params.idchestionar,
                idIntrebare: this.objIntrebare.id,

                idUser: Number(userData.Id)
            })

            //    console.warn('newIntrebare :', newIntrebare);

            if (newIntrebare.Succes) {
                this.setState({
                    lastIdIntrebare: newIntrebare.Content[0].rez
                }, () => {

                    this.getChestionar()
                })
                // this.generateRapsuns.current.getRaspunsuri();
            }

        } else {

            //   console.log('insertIntrebareFromChestionar :');


            // let newIntrebare = await ws.getData('Evaluari/InsertIntrebareDinChestionar', {
            //     idChestionar: this.props.match.params.idchestionar,
            //     idIntrebare: this.objIntrebare.id,

            //     idUser: Number(userData.Id)
            // })

            // console.warn('newIntrebare :', newIntrebare);

            // if (newIntrebare.Succes) {
            //     this.setState({
            //         lastIdIntrebare: newIntrebare.Content[0].rez
            //     }, () => {

            //         this.getChestionar()
            //     })
            //     // this.generateRapsuns.current.getRaspunsuri();
            // }
        }







    }

    getIntrebariChestionarTemplate = async (t) => {
        let ws = new WsC()

        let intrebariTemp = await ws.customSelect('select * from template_chestionare_intrebari where id_chestionar = @p1 and isnull(inactiv,0) != 1', {
            p1: t.id
        })

        console.warn('intrebariTemp :', intrebariTemp);

        if (intrebariTemp.Succes) {


            let cloneIntrebari = [...intrebariTemp.Content]

            let counter = cloneIntrebari.length

            for (let i = 0; i < counter; i++) {
                cloneIntrebari[i].temp = 1


            }

            this.setState({
                listTempIntrebari: cloneIntrebari,
                nrIntrebari: intrebariTemp.Content.length,
                objChestionarTemp: t,

            }, () => {
                this.getRaspunsuriTemp(t)
            })
        }
    }


    changeIntrebare = (ev, a) => {
        // console.log('ev.target.value :', ev.target.value);
        // console.log('intrebare to change :', a);


        let intrebari = [...this.state.listIntrebari]

        let idx = intrebari.findIndex(c => c.id === a.id)

        // console.log('idx :', idx);

        if (idx !== -1) {
            intrebari[idx].intrebare = ev.target.value

        }
        this.setState({ listIntrebari: intrebari })
    }

    previewTemplate = (t) => {

        // this.setState({
        //     isShowPreview: true
        // })

        // console.log('t :>> ', t);

        this.getIntrebariChestionarTemplate(t)
    }

    moveAllToList = async () => {

        // console.log('folosesteChestionar :');


        this.setState({ loadingDialog: true })
        // let listOfQ = []

        let listaIntrebari = []



        if (this.state.isShowIntrebariChestionarTemp) {
            //   console.log('this.state.objChestionarTemp :', this.state.listTempIntrebari);
            listaIntrebari = [...this.state.listTempIntrebari]

            let count = 0

            for (let i = 0, n = listaIntrebari.length; i < n; i++) {
                await this.moveToList(listaIntrebari[i])
                count += 1

                if (count === listaIntrebari.length) {
                    this.setState({ loadingDialog: false })
                }
            }



        } else {
            //   console.log('this.state.objChestionarTempChestMele :', this.state.listIntrebariCS);
            listaIntrebari = [...this.state.listIntrebariCS]

            let count = 0

            for (let i = 0, n = listaIntrebari.length; i < n; i++) {
                await this.moveToList(listaIntrebari[i])
                count += 1
                if (count === listaIntrebari.length) {
                    this.setState({ loadingDialog: false })
                }
            }


        }




        // await Promise.all(listaIntrebari)


    }

    moveToList = async (t) => {

        console.log('t :', t);

        //  console.log('list intrebari......... :', this.state.listIntrebari);
        let ws = new WsC();





        // let cloneIntrebari = [...this.state.listIntrebari]


        if (this.state.nrIdChestionar === 0) {

            //   console.log('this,state.nrIdChestionar :', this.state.nrIdChestionar);
            //  console.log('insert new chestionar................................. :');

            await this.insertChestionar()


        }

        if (t.temp === 1) {

            console.log('t :>> ', t);

            if (t.tip === 'grupaj' || t.tip === 'subintrebare') {
                let getSubintrebari = await ws.customSelect(`select * from template_chestionare_intrebari where id_chestionar = @p1  and id_parent = @p2  and isnull(inactiv,0) != 1`, {
                    p1: t.id_chestionar,
                    p2: t.id
                })


                if (getSubintrebari.Succes) {
                    console.log('getSubintrebari :', getSubintrebari);

                    let newIntrebareParent = await ws.getData('Evaluari/InsertIntrebareTemplate', {
                        idChestionar: this.state.nrIdChestionar,
                        idIntrebare: t.id,

                        idUser: 1
                    })

                    if (newIntrebareParent.Succes) {
                        let subIntrebari = [...getSubintrebari.Content]

                        let count = 0;

                        let lastIdIntrebare = ''

                        console.log('newIntrebareParent.Content[0].rez :', newIntrebareParent.Content[0].rez);

                        for (let i = 0, n = subIntrebari.length; i < n; i++) {

                            console.log('subIntrebari[i].id :>> ', subIntrebari[i].id);
                            let newIntrebare = await ws.getData('Evaluari/InsertIntrebareDinChestionarParentTemplate', {
                                idChestionar: this.state.nrIdChestionar,
                                idIntrebare: subIntrebari[i].id,
                                idParent: newIntrebareParent.Content[0].rez,
                                idUser: 1
                            })

                            console.log('newIntrebare :>> ', newIntrebare);

                            if (newIntrebare.Succes) {
                                count += 1
                                lastIdIntrebare = newIntrebareParent.Content[0].rez
                            }

                        }


                        if (count === subIntrebari.length) {
                            this.setState({
                                isDragCategorie: true,
                                isShowPreview: false,

                                lastIdIntrebare: lastIdIntrebare
                            }, () => {
                                this.getChestionar()

                            })
                        }
                    }


                }

            } else {
                let newIntrebare = await ws.getData('Evaluari/InsertIntrebareTemplate', {
                    idChestionar: this.state.nrIdChestionar,
                    idIntrebare: t.id,

                    idUser: 1
                })

                // console.warn('newIntrebare :', newIntrebare);
                if (newIntrebare.Succes) {

                    this.setState({
                        isDragCategorie: true,
                        isShowPreview: false,

                        lastIdIntrebare: newIntrebare.Content[0].rez
                    }, () => {
                        this.getChestionar()

                    })


                }
            }


        } else {

            // console.log('moveIntrebare :', t);

            if (t.tip === 'grupaj' || t.tip === 'subintrebare') {


                let getSubintrebari = await ws.customSelect(`select * from chestionare_intrebari where id_chestionar = @p1  and id_parent = @p2  and isnull(inactiv,0) != 1`, {
                    p1: t.id_chestionar,
                    p2: t.id
                })

                if (getSubintrebari.Succes) {
                    //    console.log('getSubintrebari :', getSubintrebari);

                    let newIntrebareParent = await ws.getData('Evaluari/InsertIntrebareDinChestionar', {
                        idChestionar: this.state.nrIdChestionar,
                        idIntrebare: t.id,
                        idUser: 1
                    })

                    if (newIntrebareParent.Succes) {
                        let subIntrebari = [...getSubintrebari.Content]

                        let count = 0;

                        let lastIdIntrebare = ''

                        //   console.log('newIntrebareParent.Content[0].rez :', newIntrebareParent.Content[0].rez);

                        for (let i = 0, n = subIntrebari.length; i < n; i++) {
                            let newIntrebare = await ws.getData('Evaluari/InsertIntrebareDinChestionarParent', {
                                idChestionar: this.state.nrIdChestionar,
                                idIntrebare: subIntrebari[i].id,
                                idParent: newIntrebareParent.Content[0].rez,
                                idUser: 1
                            })

                            if (newIntrebare.Succes) {
                                count += 1
                                lastIdIntrebare = newIntrebareParent.Content[0].rez
                            }

                        }


                        if (count === subIntrebari.length) {
                            this.setState({
                                isDragCategorie: true,
                                isShowPreview: false,

                                lastIdIntrebare: lastIdIntrebare
                            }, () => {
                                this.getChestionar()

                            })
                        }
                    }

                }


            } else {

                let newIntrebare = await ws.getData('Evaluari/InsertIntrebareDinChestionar', {
                    idChestionar: this.state.nrIdChestionar,
                    idIntrebare: t.id,
                    idUser: 1
                })

                // console.warn('newIntrebare :', newIntrebare);
                if (newIntrebare.Succes) {

                    this.setState({
                        isDragCategorie: true,

                        isShowPreview: false,
                        lastIdIntrebare: newIntrebare.Content[0].rez
                    }, () => {
                        this.getChestionar()

                    })


                }

            }

        }




        // console.log('object :', cloneIntrebari);



    }



    pozitieNoua = (arr) => {
        //   console.log('arr :', arr);


        this.setState({ listIntrebari: arr }, () => {
            this.sendOrdineLista(arr)
        })
    }

    sendOrdineLista = async (list) => {


        let ws = new WsC()

        let listaIntrebari = [...list]

        let stringIntrebari = ''

        for (let i = 0, n = listaIntrebari.length; i < n; i++) {

            stringIntrebari += `${listaIntrebari[i].id};${i}#`
        }
        // console.log('stringIntrebari :', stringIntrebari);
        //Evaluari/OrdoneazaIntrebari

        // let schimbaOrdinea =
        await ws.postDataLite('Evaluari/OrdoneazaIntrebari', stringIntrebari)

        // console.log('schimbaOrdinea :', schimbaOrdinea);

    }

    addIntrebare = () => {
        this.setState({
            isOpenIntrebare: true,
            strTitluIntrebare: '',
            objIntrebareInfo: {
                id: null,
                tip: 'radio'
            }
        }, () => {
            this.raspunsuriInsert.current.resetValues()
            this.raspunsuriInsert.current.openTrue()
        })
    }

    goToTemplate = (t) => {
        //  console.log('template :', t);

        this.setState({
            isShowChestionareT: false,
            isShowPreview: false,
            isShowIntrebariChestionarTemp: true,
            isOpenDrawerLeft: true
        })

        // this.getIntrebariChestionarTemplate(t)
    }

    goBackToChestionare = () => {

        // console.log('goBack :');

        if (0 === this.state.objCategorie.id) {
            this.setState({

                isChestionareleMele: true,
                isShowIntrebariCs: false,
                nrIntrebari: 0,
                isShowPreview: false

            })
        } else {
            this.setState({

                isShowChestionareT: true,
                isShowIntrebariChestionarTemp: false,
                nrIntrebari: 0,
                isShowPreview: false,

            })
        }

    }


    goToChestionare = async () => {

        let evData = await new LocalStorage().GetEvaluareData()

        if (Number(this.props.match.params.idsesiune) === 0) {
            this.setState({ popUpSalvare: true })
        } else {
            if (this.props.match.params.tip === 'colegi') {
                this.props.history.push(`/evaluarenouacolegi/${this.props.match.params.idsesiune}/0`)
            } else if (this.props.match.params.tip === 'sefi') {
                this.props.history.push(`/evaluarenouasefi/${this.props.match.params.idsesiune}/0`)
            } else if (this.props.match.params.tip === 'clienti') {
                this.props.history.push(`/evaluarenouaclienti/${this.props.match.params.idsesiune}/0`)
            }
        }


        // this.props.history.push('/chestionareevaluari')



    }



    folosesteTemplate = async () => {
        let ws = new WsC();



        let folosesteTemplate = await ws.update('chestionare', { este_template: this.state.objChestionar.este_template !== 1 ? 1 : 0, nume: this.state.objEvaluare.denumire, titlu: this.state.objEvaluare.denumire }, { id: this.state.objChestionar.id })


        if (folosesteTemplate.Succes) {
            let chestionar = { ...this.state.objChestionar }

            chestionar.este_template = this.state.objChestionar.este_template !== 1 ? 1 : 0

            this.setState({
                objChestionar: chestionar,
                openSettings: false
            })
        }

    }














    changeTip = (ev) => {


        this.setState({ strTip: ev.target.value })
    }




    finalizeazaIntrebare = async () => {





        let idIntrebare = this.state.objIntrebareInfo.id;



        if (this.state.strTip === 'text') {
            let ws = new WsC();

            let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', { id_intrebare: this.state.objIntrebareInfo.id, tip: this.state.strTip, label: '' })

            if (insertRaspuns.Succes) {
                this.setState({
                    isOpenIntrebare: false,
                    listTipuriIntrebari: new Utils().tipIntrebari,

                    strTip: 'radio',

                    listVarianteRaspuns: []
                }, () => {
                    // this.getChestionar()
                    this.generateRapsuns.current.getRaspunsuri(idIntrebare)
                    this.raspunsuriInsert.current.resetValues()
                })
            }
        } else {
            this.setState({
                isOpenIntrebare: false,
                listTipuriIntrebari: new Utils().tipIntrebari,

                strTip: 'radio',

                listVarianteRaspuns: []
            }, () => {
                // this.getChestionar()
                this.generateRapsuns.current.getRaspunsuri(idIntrebare)
                this.raspunsuriInsert.current.resetValues()
            })
        }
    }

    openEditIntrebare = (i) => {
        // console.log('i :', i);

        this.setState({
            objIntrebareInfo: i,
            isOpenIntrebare: true,
            strTitluIntrebare: i.intrebare,
            strTip: i.tip
        }, () => {
            this.raspunsuriInsert.current.getTipIntrebare()
            this.raspunsuriInsert.current.getRaspunsuri()
            this.generateRapsuns.current.getRaspunsuri()
        })
    }





    handleChangePanel = (name) => {

        console.log('namePanel :>> ', name);
        this.setState({ [name]: this.state[name] ? false : true })
    }



    changeEvalObj = ev => {
        let evaluare = { ...this.state.objEvaluare }

        evaluare[ev.target.name] = ev.target.value

        this.setState({ objEvaluare: evaluare })
    }

    folosestePuncte = async () => {
        let evaluare = { ...this.state.objEvaluare }

        let ws = new WsC();

        evaluare.foloseste_puncte = evaluare.foloseste_puncte === 1 ? 0 : 1

        let update = await ws.update('evaluari', { foloseste_puncte: evaluare.foloseste_puncte }, { id: evaluare.id })

        if (update.Succes) {
            this.setState({
                objEvaluare: evaluare,
                openSettings: false
            })
        }
    }



    closeIntrebare = async () => {




        console.log('closeIntrebare :>> ',);

        this.setState({
            isOpenIntrebare: false,
            strTitluIntrebare: '',
            objIntrebareInfo: { id: null, tip: 'radio' },
            listVarianteRaspuns: []
        }, () => {
            this.getChestionar()
            this.raspunsuriInsert.current.resetValues()
            this.generateRapsuns.current.getRaspunsuri()
        })
    }








    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }

    dataAzi = () => {


        let dataAzi = this.u.defaultData()

        if (this.dictionary.date === 'en') {
            return this.u.dataPrescurtataEng(dataAzi)
        } else {
            return this.u.dataPrescurtataRomana(dataAzi)
        }
    }



    goToEvaluari = () => {

        if (this.props.match.params.tip === 'colegi') {
            this.props.history.push(`/evaluaricolegi`)
        } else if (this.props.match.params.tip === 'sefi') {
            this.props.history.push(`/evaluarisefi`)
        } else if (this.props.match.params.tip === 'clienti') {
            this.props.history.push(`/evaluariclienti`)
        }
    }


    changeTitlu = (ev) => {
        let obj = { ...this.state.objChestionar }

        obj['titlu'] = ev.target.value

        this.setState({ objChestionar: obj })
    }


    render() {
        return (
            <div className='chestionare-background-div'
            // style={{ backgroundImage: `url('${backgroundCh}')` }}
            >

                <CustomAppBar history={this.props.history} appBarButtons={this.buildAppBarButtons()} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />


                <LoadingDialog
                    open={this.state.loadingDialog}
                    dialogClose={() => { this.setState({ loadingDialog: false }) }}
                    title={'Chestionarul se cloneaza, va rugam asteptati !'}
                />

                <LoadingDialog
                    open={this.state.loadingChestionareUsers}
                    dialogClose={() => { this.setState({ loadingChestionareUsers: false }) }}
                    title={'Va rugam asteptati !'}
                />


                <Snackbar
                    className='pm-snack'
                    key={new Date().getTime()}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    TransitionComponent={Fade}
                    open={this.state.isOpenSnack}
                    autoHideDuration={3000}
                    onClose={() => { this.setState({ isOpenSnack: false }) }}

                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id" className='pm-snack-text'>{this.state.strMesajSnack}</span>}
                />

                <Grid container >
                    <Grid style={{ margin: 'auto', marginBottom: 40 }} item xs={12} sm={12} md={9} lg={9} xl={9}>


                        <h1 className='pm-title-big' style={{ marginLeft: 40, display: 'flex', justifyContent: 'space-between' }}>



                            <input style={{
                                fontSize: 30, width: '80%', textAlign: 'left', backgroundColor: 'transparent', color: 'black',
                                fontWeight: 600, border: 'none'
                            }}
                                type='text' value={this.state.objChestionar.titlu || ""}
                                placeholder='Titlu Chestionar'
                                onChange={this.changeTitlu} onBlur={this.updateTitluChestionar} />

                            <div style={{ display: 'inline', position: 'relative', marginLeft: 20 }}>
                                <CogSolid onClick={() => { this.setState({ openSettings: this.state.openSettings ? false : true }) }} className='textSecondary' style={{ verticalAlign: 'bottom', width: 40, height: 40, cursor: 'pointer' }} />

                                {this.state.openSettings &&
                                    <ul className='menu-settings' style={{}}>

                                        <li className='chestionar-settings-li' style={{ color: this.state.objChestionar.este_template === 1 ? '#00c0f4' : '' }} onClick={this.folosesteTemplate}>  {this.state.objChestionar.este_template === 1 ? 'Este template' : 'Foloseste ca template'}</li>
                                        <li className='chestionar-settings-li textRed' onClick={() => { this.setState({ isOpenDeleteChestionar: true }) }}>Sterge Chestionar</li>



                                    </ul>

                                }
                            </div>

                        </h1>

                        {this.state.popUpSalvare &&
                            <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i> <span style={{ fontSize: 11, fontWeight: 500 }}>
                                        Ai salvat chestionarul tau nou creat. Pentru a-l folosi intr-o evaluare, acceseaza din meniul principal sectiuniile de Evaluare sau <span onClick={this.goToEvaluari} style={{ textDecoration: 'underline', cursor: 'pointer' }}>Click Aici</span> pentru a accesa rapid </span>
                                </div>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} onClick={() => { this.setState({ popUpSalvare: false }) }} className='material-icons'>clear</i>
                                </div>

                            </div>
                        }







                        <Grid container style={{ margin: 'auto', height: '80vh', position: 'relative', scrollbarColor: 'transparent', scrollbarWidth: 0 }} >





                            <Hidden lgUp>
                                <Drawer style={{ width: this.getWindowDimentions(), backgroundColor: '#e2e2e0 ', }} open={this.state.isOpenDrawerLeft}
                                    onClose={() => { this.setState({ isOpenDrawerLeft: false }) }} anchor='left' >
                                    <div style={{
                                        width: this.getWindowDimentions(),
                                        minWidth: 400,

                                        backgroundColor: '#e2e2e0 ',
                                        height: '100%',
                                        textAlign: 'center',
                                        overflow: 'hidden'
                                    }}>
                                        {
                                            this.state.isShowCategorii &&
                                            <div >

                                                <div style={{
                                                    backgroundColor: 'white',
                                                    borderRadius: 10,
                                                    position: 'relative',
                                                    width: '95%',
                                                    margin: 'auto',
                                                    marginBottom: 30,
                                                    padding: 0,
                                                    height: 'inherit',
                                                    overflow: 'scroll',
                                                    scrollbarColor: 'transparent', scrollbarWidth: 0

                                                }}>
                                                    <div>
                                                        <div className='stickyTitle' >


                                                            <h2 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}><span style={{ fontWeight: 600 }}>Template Chestionare</span>
                                                                <i onClick={() => { this.setState({ isOpenDrawerLeft: false }) }} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>close</i></h2>
                                                        </div>

                                                        <Divider className='pm-divider' />
                                                        <ListaChestionare
                                                            fontSize={15}
                                                            backgroundColor={'transparent'}
                                                            width={'100%'}
                                                            // title="Template Chestionare"
                                                            listaChestionare={this.state.listCategorii}
                                                            goToChestionar={this.goToCategorieTemplate} />

                                                    </div>

                                                    <div>
                                                        <div className='stickyTitle' >


                                                            <h2 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}><span style={{ fontWeight: 600 }}>Chestionarele Mele</span> </h2>
                                                        </div>
                                                        <Divider className='pm-divider' />
                                                        <ListaChestionare
                                                            backgroundColor={'transparent'}
                                                            fontSize={15}
                                                            width={'100%'}
                                                            // title="Chestionarele mele"
                                                            listaChestionare={this.state.categoriileMele}
                                                            goToChestionar={this.goToChestionareleMele} />
                                                    </div>
                                                </div>




                                            </div>
                                        }
                                        {
                                            this.state.isChestionareleMele &&

                                            <div style={{
                                                backgroundColor: 'white',
                                                borderRadius: 10,
                                                position: 'relative',
                                                width: '95%',
                                                margin: 'auto',
                                                marginBottom: 30,
                                                padding: 0,
                                                height: 'inherit',
                                                overflow: 'scroll',
                                                scrollbarColor: 'transparent', scrollbarWidth: 0

                                            }}>
                                                <div className='stickyTitle' >


                                                    <h2 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}>
                                                        <i onClick={this.goBackCategorii} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>keyboard_arrow_left</i>
                                                        <span style={{ fontWeight: 600 }}> {this.state.objCategorie.nume}</span>
                                                        <i onClick={() => { this.setState({ isOpenDrawerLeft: false }) }} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>close</i></h2>
                                                </div>
                                                <Divider className='pm-divider' />
                                                <ListaChestionare
                                                    fontSize={15}
                                                    backgroundColor={'transparent'}
                                                    goBack={true}
                                                    title={this.state.objCategorie.nume}
                                                    dragStart={this.onDragStartChestionar}
                                                    isDragable={true}
                                                    goBackFunc={this.goBackCategorii}
                                                    width={'100%'}
                                                    listaChestionare={this.state.listChestionare}
                                                    goToChestionar={this.goToChestionarSelectat} />


                                            </div>

                                        }

                                        {
                                            this.state.isShowChestionareT &&

                                            <div style={{
                                                backgroundColor: 'white',
                                                borderRadius: 10,
                                                position: 'relative',
                                                width: '95%',
                                                margin: 'auto',
                                                marginBottom: 30,
                                                padding: 0,
                                                height: 'inherit',
                                                overflow: 'scroll',
                                                scrollbarColor: 'transparent', scrollbarWidth: 0

                                            }}>
                                                <div className='stickyTitle' >


                                                    <h2 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}>
                                                        <i onClick={this.goBackCategorii} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>keyboard_arrow_left</i>
                                                        <span style={{ fontWeight: 600 }}> {this.state.objCategorie.nume}</span>
                                                        <i onClick={() => { this.setState({ isOpenDrawerLeft: false }) }} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>close</i></h2>
                                                </div>
                                                <Divider className='pm-divider' />
                                                <ListaChestionare
                                                    fontSize={15}
                                                    goBack={true}
                                                    title={this.state.objCategorie.nume}
                                                    backgroundColor={'transparent'}
                                                    goBackFunc={this.goBackCategorii}
                                                    width={'100%'}
                                                    listaChestionare={this.state.listChestionareTemplate}
                                                    goToChestionar={this.previewTemplate} />


                                            </div>

                                        }



                                        {this.state.isShowIntrebariChestionarTemp &&
                                            <div style={{
                                                backgroundColor: 'white',
                                                borderRadius: 10,
                                                position: 'relative',
                                                width: '95%',
                                                margin: 'auto',
                                                marginBottom: 30,
                                                padding: 0,
                                                height: 'inherit',
                                                overflow: 'scroll',
                                                scrollbarColor: 'transparent', scrollbarWidth: 0

                                            }}>
                                                <div className='stickyTitle' >


                                                    <h2 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}>
                                                        <i onClick={this.goBackToChestionare} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>keyboard_arrow_left</i>
                                                        <span style={{ fontWeight: 600, display: 'block', textAlign: 'left', lineHeight: '20px' }}>
                                                            <span style={{ display: 'block' }}>{
                                                                this.state.objChestionarTemp.nume}</span>  <span className='textSecondary' style={{ fontSize: 15 }}>{this.state.objCategorie.nume}
                                                            </span>
                                                        </span>
                                                        <i onClick={this.moveAllToList} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>assignment_turned_in</i>
                                                    </h2>
                                                </div>
                                                <Divider className='pm-divider' />
                                                <ListaIntrebariChestionareTemplate
                                                    listaIntrebari={this.state.listTempIntrebari}
                                                    // titluChestionar={this.state.objChestionarTemp.nume}
                                                    titluChestionarColor={'transparent'}

                                                    backgroundColor={'transparent'}
                                                    dragStart={this.onDragStartTemplate}
                                                    moveToList={this.moveToList}
                                                    importaChestionar={this.moveAllToList}

                                                    isTemplate={true}
                                                    isIntrebariTemplate={true}
                                                    openIntrebare={() => { this.setState({ isOpenIntrebare: true }) }} />


                                            </div>

                                        }

                                        {this.state.isShowIntrebariCs &&

                                            <div style={{
                                                backgroundColor: 'white',
                                                borderRadius: 10,
                                                position: 'relative',
                                                width: '95%',
                                                margin: 'auto',
                                                marginBottom: 30,
                                                padding: 0,
                                                height: 'inherit',
                                                overflow: 'scroll',
                                                scrollbarColor: 'transparent', scrollbarWidth: 0

                                            }}>
                                                <div className='stickyTitle' >


                                                    <h2 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}>
                                                        <i onClick={this.goBackToChestionare} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>keyboard_arrow_left</i>
                                                        <span style={{ fontWeight: 600, display: 'block', textAlign: 'left', lineHeight: '20px' }}>
                                                            <span style={{ display: 'block' }}>{
                                                                this.state.objChestionarTemp.nume}</span>  <span className='textSecondary' style={{ fontSize: 15 }}>{this.state.objCategorie.nume}
                                                            </span>
                                                        </span>
                                                        <i onClick={this.moveAllToList} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>assignment_turned_in</i>
                                                    </h2>
                                                </div>
                                                <Divider className='pm-divider' />
                                                <ListaIntrebariChestionareTemplate
                                                    listaIntrebari={this.state.listIntrebariCS}
                                                    backgroundColor={'transparent'}
                                                    titluChestionarColor={'rgb(114,119,114)'}

                                                    dragStart={this.onDragStartTemplate}
                                                    moveToList={this.moveToList}
                                                    importaChestionar={this.moveAllToList}

                                                    isTemplate={true}
                                                    openIntrebare={() => { this.setState({ isOpenIntrebare: true }) }} />


                                            </div>

                                        }


                                    </div>
                                </Drawer>
                            </Hidden>

                            <Grid item xs={12} sm={12} md={12} lg={8} xl={8} style={{ height: '100%', overflow: 'hidden', position: 'relative', marginBottom: 40, scrollbarColor: 'transparent', scrollbarWidth: 0 }}    >



                                <div id='chestionare-list-intrebari-scroll-view' onDragOver={(ev) => { this.dragOver(ev) }} style={{ height: '100%', overflow: 'auto', backgroundColor: 'white', borderRadius: 10, scrollbarColor: 'transparent', scrollbarWidth: 0 }} onDrop={(ev) => { this.drop(ev) }}>





                                    <ListaIntrebariChestionare
                                        // titluChestionar={this.state.objEvaluare.denumire}
                                        folosestePuncte={this.state.objEvaluare.foloseste_puncte === 1 ? true : false}
                                        backgroundColor={'transparent'}
                                        changeTitlu={this.changeText('denumire')}
                                        updateTitlu={this.updateTitluChestionar}
                                        listaIntrebari={this.state.listIntrebari}
                                        goToIntrebare={this.goToIntrebare}
                                        pozitieNoua={this.pozitieNoua}
                                        addIntrebare={this.addIntrebare}
                                        changeIntrebare={this.changeIntrebare}
                                        deleteIntrebare={this.deleteIntrebare}
                                        isUpdateC={this.state.isUpdateChestionar}
                                        openEdit={this.openEditIntrebare}
                                        showTabs={true}
                                        ref={this.generateRapsuns}
                                        openIntrebare={() => { this.setState({ isOpenIntrebare: true }, () => { this.raspunsuri.current.openTrue() }) }} />

                                    {/* {this.state.listIntrebari.length > 0 && */}
                                    {/* <Button style={{ marginTop: 15, 
                marginRight:10, 
                display:'block', 
                position:'fixed', 
                bottom:20,
                right:'25%' }} variant="outlined" onClick={()=>{this.setState({isOpenEvalNoua:true})}} className='pm-save-button'>
                Mai Departe
            </Button> */}

                                    {/* }  */}


                                    <Hidden lgUp>
                                        <div style={{ backgroundColor: 'white', position: "-webkit-sticky", position: 'sticky', bottom: 0, paddingTop: 20, }}>
                                            <Button style={{ width: '90%', marginBottom: 20 }} variant="contained" onClick={this.addIntrebare} className='chestionare-adauga-raspuns-button' >
                                                {/* <i className='material-icons'>add_circle_outline</i>   */}
                                                Adauga intrebare
                                            </Button>
                                        </div>

                                    </Hidden>


                                    <Hidden mdDown>
                                        <div style={{ backgroundColor: 'white', position: "-webkit-sticky", position: 'sticky', display: 'flex', justifyContent: 'space-between', bottom: 0, paddingTop: 20, width: '95%' }}>
                                            <Button style={{ width: 'fit-content', marginBottom: 20, marginLeft: 20 }} variant="contained" onClick={this.addIntrebare} className='chestionare-adauga-raspuns-button'>
                                                {/* <i className='material-icons'>add_circle_outline</i>   */}
                                                Adauga intrebare
                                            </Button>

                                            <Button style={{ width: 'fit-content', marginBottom: 20, marginLeft: 20 }} variant="contained" onClick={this.goToChestionare} className='chestionare-salveaza-button'>
                                                {/* <i className='material-icons'>add_circle_outline</i>   */}
                                                Salveaza
                                            </Button>
                                        </div>
                                    </Hidden>




                                </div>

                            </Grid>




                            <Hidden mdDown>
                                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{
                                    height: '100%',
                                    textAlign: 'center',
                                    overflow: 'hidden'
                                }} >




                                    <div style={{
                                        backgroundColor: 'white',
                                        borderRadius: 10,
                                        position: 'relative',
                                        width: '95%',
                                        margin: 'auto',
                                        marginBottom: 30,
                                        padding: 0,
                                        height: this.state.panelTempChestionar ? '100%' : '80px',
                                        overflow: 'scroll',
                                        scrollbarColor: 'transparent', scrollbarWidth: 0
                                    }}>
                                        <div className='stickyTitle' >


                                            <h3 onClick={() => { this.handleChangePanel('panelTempChestionar') }} style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}><span style={{ fontWeight: 600 }}>
                                                {/* <FileInvoiceSolid className='iconSvg' style={{ verticalAlign: 'middle' }} /> */}
                                                Template Intrebari</span><i className='material-icons iconFontSize textSecondary'>{this.state.panelTempChestionar ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i> </h3>
                                            {this.state.panelTempChestionar &&

                                                <Divider className='pm-divider' />
                                            }

                                        </div>

                                        <Accordion style={{ margin: 'auto', boxShadow: 'none', width: '95%' }} expanded={this.state.panelTempChestionar} onChange={() => { this.handleChangePanel('panelTempChestionar') }}>


                                            {/* {this.state.isShowPreview !== true && */}

                                            <AccordionDetails style={{ display: 'block', padding: 0 }}>

                                                <ListaIntrebariChestionareTemplate
                                                    titluChestionar={'Template intrebari'}
                                                    backgroundColor={'white'}
                                                    titluChestionarColor={'rgb(114,119,114)'}
                                                    listaIntrebari={this.state.listTemplateIntrebari}
                                                    dragStart={this.onDragStartTemplate}
                                                    moveToList={this.moveToList}
                                                    raspunsuriInsert={this.raspunsuriInsert}
                                                    left={false}
                                                    isIntrebariTemplate={true}
                                                    isTemplate={true}
                                                    openIntrebare={() => { this.setState({ isOpenIntrebare: true }) }} />


                                            </AccordionDetails>
                                        </Accordion>

                                    </div>








                                    {/* <InfoTemplateC
            descriereChestionar={this.state.objChestionarTemp.nume}
            rezultateChestionar={''}
            numarIntrebari={this.state.nrIntrebari}
            timpCompletare={''}
        /> */}

                                    {/* <Divider className="chestionare-divider" /> */}
                                    {
                                        this.state.isShowCategorii &&
                                        <div >

                                            <div style={{
                                                backgroundColor: 'white',
                                                borderRadius: 10,
                                                position: 'relative',
                                                width: '95%',
                                                margin: 'auto',
                                                marginBottom: 30,
                                                padding: 0,
                                                overflow: 'scroll',
                                                scrollbarColor: 'transparent', scrollbarWidth: 0,
                                                maxHeight: '70vh'

                                            }}>
                                                <div>
                                                    <div className='stickyTitle' >


                                                        <h3 onClick={() => { this.handleChangePanel('panelTempCategorii') }} style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}><span style={{ fontWeight: 600 }}>
                                                            {/* <FolderSolid className='iconSvg' style={{ verticalAlign: 'middle' }} />  */}
                                                            Template Chestionare</span><i className='material-icons iconFontSize textSecondary'>{this.state.panelTempCategorii ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i> </h3>
                                                    </div>
                                                    {this.state.panelTempCategorii &&

                                                        <Divider className='pm-divider' />
                                                    }
                                                    {this.state.panelTempCategorii &&

                                                        <Accordion style={{ margin: 'auto', boxShadow: 'none', width: '95%' }} expanded={this.state.panelTempCategorii} onChange={() => { this.handleChangePanel('panelTempCategorii') }}>


                                                            {/* {this.state.isShowPreview !== true && */}





                                                            <AccordionDetails style={{ display: 'block', padding: 0 }}>

                                                                <ListaChestionare
                                                                    fontSize={15}
                                                                    backgroundColor={'transparent'}
                                                                    width={'100%'}
                                                                    // title="Template Chestionare"
                                                                    listaChestionare={this.state.listCategorii}
                                                                    goToChestionar={this.goToCategorieTemplate} />

                                                                <div>
                                                                    <div className='stickyTitle' >


                                                                        <h3 style={{ fontFamily: 'Open Sans', margin: 20, }}><span style={{ fontWeight: 600 }}>Chestionarele Mele</span> </h3>
                                                                    </div>
                                                                    <Divider className='pm-divider' />

                                                                    <ListaChestionare
                                                                        backgroundColor={'transparent'}
                                                                        fontSize={15}
                                                                        width={'100%'}
                                                                        // title="Chestionarele mele"
                                                                        listaChestionare={this.state.categoriileMele}
                                                                        goToChestionar={this.goToChestionareleMele} />
                                                                </div>

                                                            </AccordionDetails>
                                                        </Accordion>
                                                    }


                                                </div>


                                            </div>




                                        </div>
                                    }
                                    {
                                        this.state.isChestionareleMele &&

                                        <div style={{
                                            backgroundColor: 'white',
                                            borderRadius: 10,
                                            position: 'relative',
                                            width: '95%',
                                            margin: 'auto',
                                            marginBottom: 30,
                                            padding: 0,
                                            height: 'inherit',
                                            overflow: 'scroll',
                                            scrollbarColor: 'transparent', scrollbarWidth: 0,
                                            maxHeight: '70vh'

                                        }}>
                                            <div className='stickyTitle' >


                                                <h3 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', textAlign: 'left' }}>
                                                    <i onClick={this.goBackCategorii} style={{ verticalAlign: 'middle', marginRight: 20 }} className='material-icons iconFontSize textSecondary'>keyboard_arrow_left</i>
                                                    <span style={{ fontWeight: 600 }}> {this.state.objCategorie.nume}</span> </h3>
                                            </div>
                                            <Divider className='pm-divider' />
                                            <ListaChestionare
                                                fontSize={15}
                                                backgroundColor={'transparent'}
                                                goBack={true}
                                                title={this.state.objCategorie.nume}
                                                dragStart={this.onDragStartChestionar}
                                                isDragable={true}
                                                goBackFunc={this.goBackCategorii}
                                                width={'100%'}
                                                listaChestionare={this.state.listChestionare}
                                                goToChestionar={this.goToChestionarSelectat} />


                                        </div>
                                    }

                                    {
                                        this.state.isShowChestionareT &&
                                        <div style={{
                                            backgroundColor: 'white',
                                            borderRadius: 10,
                                            position: 'relative',
                                            width: '95%',
                                            margin: 'auto',
                                            marginBottom: 30,
                                            padding: 0,
                                            height: 'inherit',
                                            overflow: 'scroll',
                                            scrollbarColor: 'transparent', scrollbarWidth: 0,
                                            maxHeight: '70vh'

                                        }}>
                                            <div className='stickyTitle' >


                                                <h3 style={{ fontFamily: 'Open Sans', margin: 20, textAlign: 'left' }}>
                                                    <i onClick={this.goBackCategorii} style={{ verticalAlign: 'middle', marginRight: 20 }} className='material-icons iconFontSize textSecondary'>keyboard_arrow_left</i>
                                                    <span style={{ fontWeight: 600 }}> {this.state.objCategorie.nume}</span> </h3>
                                            </div>
                                            <Divider className='pm-divider' />
                                            <ListaChestionare
                                                fontSize={15}
                                                goBack={true}
                                                title={this.state.objCategorie.nume}
                                                backgroundColor={'transparent'}
                                                goBackFunc={this.goBackCategorii}
                                                width={'100%'}
                                                listaChestionare={this.state.listChestionareTemplate}
                                                goToChestionar={this.previewTemplate} />


                                        </div>
                                    }

                                    {this.state.isShowIntrebariChestionarTemp &&
                                        <div style={{
                                            backgroundColor: 'white',
                                            borderRadius: 10,
                                            position: 'relative',
                                            width: '95%',
                                            margin: 'auto',
                                            marginBottom: 30,
                                            padding: 0,
                                            height: 'inherit',
                                            overflow: 'scroll',
                                            scrollbarColor: 'transparent', scrollbarWidth: 0,
                                            maxHeight: '70vh'

                                        }}>
                                            <div className='stickyTitle' >


                                                <h3 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}>
                                                    <i onClick={this.goBackToChestionare} style={{ verticalAlign: 'middle' }} className='material-icons iconFontSize textSecondary'>keyboard_arrow_left</i>
                                                    <span style={{ fontWeight: 600, display: 'block', textAlign: 'left', lineHeight: '20px' }}>
                                                        <span style={{ display: 'block' }}>{
                                                            this.state.objChestionarTemp.nume}</span>  <span className='textSecondary' style={{ fontSize: 15 }}>{this.state.objCategorie.nume}
                                                        </span>
                                                    </span>
                                                    <i onClick={this.moveAllToList} className='material-icons iconFontSize textSecondary'>assignment_turned_in</i>
                                                </h3>
                                            </div>
                                            <Divider className='pm-divider' />
                                            <ListaIntrebariChestionareTemplate
                                                listaIntrebari={this.state.listTempIntrebari}
                                                // titluChestionar={this.state.objChestionarTemp.nume}
                                                titluChestionarColor={'transparent'}

                                                backgroundColor={'transparent'}
                                                dragStart={this.onDragStartTemplate}
                                                moveToList={this.moveToList}
                                                importaChestionar={this.moveAllToList}

                                                isTemplate={true}
                                                isIntrebariTemplate={true}
                                                openIntrebare={() => { this.setState({ isOpenIntrebare: true }) }} />


                                        </div>
                                    }

                                    {this.state.isShowIntrebariCs &&
                                        <div style={{
                                            backgroundColor: 'white',
                                            borderRadius: 10,
                                            position: 'relative',
                                            width: '95%',
                                            margin: 'auto',
                                            marginBottom: 30,
                                            padding: 0,
                                            height: 'inherit',
                                            overflow: 'scroll',
                                            scrollbarColor: 'transparent', scrollbarWidth: 0,
                                            maxHeight: '70vh'

                                        }}>
                                            <div className='stickyTitle' >


                                                <h3 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}>
                                                    <i onClick={this.goBackToChestionare} style={{ verticalAlign: 'middle' }} className='material-icons iconFontSize textSecondary'>keyboard_arrow_left</i>
                                                    <span style={{ fontWeight: 600, display: 'block', textAlign: 'left', lineHeight: '20px' }}>
                                                        <span style={{ display: 'block' }}>{
                                                            this.state.objChestionarTemp.nume}</span>  <span className='textSecondary' style={{ fontSize: 15 }}>{this.state.objCategorie.nume}
                                                        </span>
                                                    </span>
                                                    <i onClick={this.moveAllToList} className='material-icons iconFontSize textSecondary'>assignment_turned_in</i>
                                                </h3>
                                            </div>
                                            <Divider className='pm-divider' />
                                            <ListaIntrebariChestionareTemplate
                                                listaIntrebari={this.state.listIntrebariCS}
                                                backgroundColor={'transparent'}
                                                titluChestionarColor={'rgb(114,119,114)'}

                                                dragStart={this.onDragStartTemplate}
                                                moveToList={this.moveToList}
                                                importaChestionar={this.moveAllToList}

                                                isTemplate={true}
                                                openIntrebare={() => { this.setState({ isOpenIntrebare: true }) }} />


                                        </div>
                                    }

                                </Grid>
                            </Hidden>

                            <Hidden lgUp>
                                <Drawer style={{ width: this.getWindowDimentions() }} open={this.state.isOpenDrawerRight}
                                    onClose={() => { this.setState({ isOpenDrawerRight: false }) }} anchor='right' >
                                    <div style={{
                                        width: this.getWindowDimentions(),
                                        maxWidth: this.getWindowDimentions(),

                                        backgroundColor: '#e2e2e0 ',
                                        height: '100%',
                                        textAlign: 'center',
                                        overflow: 'hidden'
                                    }}>

                                        <div style={{
                                            backgroundColor: 'white',
                                            borderRadius: 10,
                                            position: 'relative',
                                            width: '95%',
                                            margin: 'auto',
                                            marginBottom: 30,
                                            padding: 0,
                                            height: 'inherit',
                                            overflow: 'scroll',
                                            scrollbarColor: 'transparent', scrollbarWidth: 0
                                        }}>
                                            <div className='stickyTitle' >


                                                <h2 style={{ fontFamily: 'Open Sans', margin: 20, display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ fontWeight: 600 }}>Template Intrebari</span>
                                                    <i onClick={() => { this.setState({ isOpenDrawerRight: false }) }} style={{ lineHeight: '30px' }} className='material-icons iconFontSize textSecondary'>close</i></h2>

                                                <Divider className='pm-divider' />
                                            </div>
                                            <ListaIntrebariChestionareTemplate
                                                titluChestionar={'Template intrebari'}
                                                backgroundColor={'white'}
                                                titluChestionarColor={'rgb(114,119,114)'}
                                                listaIntrebari={this.state.listTemplateIntrebari}
                                                dragStart={this.onDragStartTemplate}
                                                moveToList={this.moveToList}
                                                raspunsuriInsert={this.raspunsuriInsert}
                                                left={false}
                                                isIntrebariTemplate={true}
                                                isTemplate={true}
                                                openIntrebare={() => { this.setState({ isOpenIntrebare: true }) }} />
                                        </div>



                                    </div>
                                </Drawer>
                            </Hidden>


                        </Grid>

                    </Grid>

                </Grid>



                <AddIntrebare
                    open={this.state.isOpenIntrebare}
                    dialogClose={this.closeIntrebare}
                    nume={this.state.strTitluIntrebare}
                    numeChange={(ev) => { this.setState({ strTitluIntrebare: ev.target.value }) }}
                    motivatieChange={this.motivatieChange}
                    tip={this.state.strTip}
                    tipChange={(ev) => { this.changeTip(ev) }}
                    tipuriIntrebari={this.state.listTipuriIntrebari}
                    objIntrebareInfo={this.state.objIntrebareInfo}
                    raspunsuri={this.state.listVarianteRaspuns}
                    insert={this.insertIntrebare}
                    updateIntrebare={this.updateIntrebare}
                    getRaspunsuri={this.getRaspunsuri}
                    getChestionar={this.getChestionar}
                    finalizeaza={this.finalizeazaIntrebare}
                    chestionarInfo={this.state.objChestionar}
                    ref={this.raspunsuriInsert} />

                <DialogRaspunsuri
                    open={this.state.isOpenUpdateIntrebare}
                    dialogClose={() => { this.setState({ isOpenUpdateIntrebare: false, strTitluIntrebare: '', listVarianteRaspuns: [] }) }}
                    nume={this.state.strTitluIntrebare}
                    numeChange={(ev) => { this.setState({ strTitluIntrebare: ev.target.value }) }}
                    objIntrebareInfo={this.state.objIntrebareInfo}
                    tipChange={(ev) => { this.changeTip(ev) }}
                    tipuriIntrebari={this.state.listTipuriIntrebari}
                    raspunsuri={this.state.listVarianteRaspuns}
                    getRaspunsuri={this.getRaspunsuri}
                    isUpdate={this.state.isUpdateChestionar}
                    getChestionar={this.getChestionar}
                    ref={this.raspunsuri}
                    updateIntrebare={this.updateIntrebare}
                    stergeIntrebare={() => { this.deleteIntrebare(this.state.objIntrebareInfo) }}
                />




                <AlertChestionar
                    open={this.state.isOpenDeleteChestionar}
                    dialogClose={() => { this.setState({ isOpenDeleteChestionar: false }) }}
                    title={'Esti sigur ca vrei sa stergi chestionarul ?'}
                    yesFunction={this.deleteChestionar}
                />


            </div >
        );
    }
}